/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferServiceDetailResponse } from '../../models/offer-service-detail-response';

export interface GetOfferService$Params {
  id: number;
  extraServiceId: number;
}

export function getOfferService(http: HttpClient, rootUrl: string, params: GetOfferService$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferServiceDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferService.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('extraServiceId', params.extraServiceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferServiceDetailResponse>;
    })
  );
}

getOfferService.PATH = '/offers/{id}/services/{extraServiceId}';
